module.exports = __webpack_public_path__ + "static/media/ENGProjectPreview1870@2x.209b79f1.jpg";